/**
 * ERP Financial API client for fetching eligible child codes of a group.
 */

import { baseErpRequest } from './erpRequest';
import type { ErpSegmentGroupsPageInfo } from './segmentGroups';
import type { ErpApiError } from './types';

export type ObjectCodeType =
  | 'ASSETS'
  | 'LIABILITIES'
  | 'FUND_BALANCE_AND_NET_POSITION'
  | 'REVENUES'
  | 'EXPENDITURES'
  | 'NET_ACCOUNT';

export type EligibleChildCode = {
  id: number;
  segmentCode: string;
  active: boolean;
  segmentId?: number;
  segmentName?: string;
  description?: string;
  defaultParentSegmentGroup?: number;
  defaultParentSegmentGroupName?: string;
  tags?: string[];
  objectCodeType?: ObjectCodeType;
  fundOrgUnitCode?: number;
  fundOrgUnitId?: number;
  importFileId?: number;
};

export type EligibleChildCodesResponse = {
  message: string;
  statusCode: number;
  data: {
    data: EligibleChildCode[];
    pageInfo: ErpSegmentGroupsPageInfo;
  };
  errors?: ErpApiError[] | null;
};

export type GetEligibleChildCodesParams = {
  segmentId: number;
  groupId: number;
};

export const getEligibleChildCodes = async (
  { segmentId, groupId }: GetEligibleChildCodesParams,
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<EligibleChildCodesResponse> => {
  return (await baseErpRequest(
    `/segments/${encodeURIComponent(segmentId)}/groups/${encodeURIComponent(groupId)}/eligible-child-codes`,
    clientOptions,
    hostUrl
  )
    .get()
    .json()) as EligibleChildCodesResponse;
};
